<template>
	<div class="bg">
		<el-container>
			<el-header style="z-index: 1;display: flex;align-items: center;">
				<div style="display: flex;align-items: center;" @click="$router.push('/')">
					<el-image style="width: 150px;margin-top: 20px;" :src="require('@/assets/logo-xjj.png')"></el-image>
				</div>
				<div style="margin-left: 20px;cursor: pointer;" @click="$router.push('/')">首页</div>
			</el-header>
			<el-main>
				<div style="display: flex;justify-content: center;padding-top: 4rem;">
					<div
						style="display: flex;flex-direction: column;justify-content: center;width: 100%;max-width: 24rem;">

						<div style="margin:0px 0px;display: flex;flex-direction: column;justify-content: center;">
							<div style="font-size: 17px;text-align: center;padding-bottom: 3rem;max-width: 43rem;">
								<div class="h1">欢迎回到
									<div style="margin: 0px 5px;">星剪辑</div>
								</div>
								<div style="margin-top: 10px;">一键轻松制作短视频</div>
							</div>

							<div>
								<div style="margin-bottom: 5px;font-size: 13px;color: #777;">手机号</div>
								<el-input v-model="phone" placeholder="手机号/用户名" style="padding: ;"></el-input>
							</div>
							<div style="margin-top: 30px;">
								<div style="margin-bottom: 5px;font-size: 13px;color: #777;">密码</div>
								<el-input v-model="password" placeholder="密码" show-password></el-input>
							</div>

							<div style="margin-top: 40px;">
								<el-button type="primary" style="width:100%;" @click="login()" round>登录</el-button>
							</div>

							<div style="margin-top:20px;color:#777;cursor: pointer;font-size: 14px;text-align: center;align-items: center;display: flex;justify-content: center;"
								@click="$router.push('/register')">
								<div>没有账户？</div>
								<el-link type="primary" style="font-size: 14px;">立即注册</el-link>
							</div>

							<div
								style="display: flex;align-items: center;flex-wrap: wrap;margin-top: 30px;font-size: 13px;justify-content: center;">
								继续表示您同意我们的 <el-link type="primary" @click="yhtk = true"> 用户条款 </el-link> 和 <el-link
									type="primary" @click="yszc = true"> 隐私协议 </el-link>
							</div>
							<el-dialog title="《用户条款》" :visible.sync="yhtk" append-to-body
                                custom-class="newdialog_share">
                                <div style="height: 500px;">
                                    <!-- <iframe src="../../../static/user.html" frameborder="0" style="width: 100%;height: 100%;"></iframe> -->
                                </div>
                            </el-dialog>
                            <el-dialog title="《隐私协议》" :visible.sync="yszc" append-to-body
                                custom-class="newdialog_share">
                                <div style="height: 500px;">
                                    <!-- <iframe src="../../../static/yszc.html" frameborder="0"  style="width: 100%;height: 100%;"></iframe> -->
                                </div>
                            </el-dialog>
						</div>


					</div>
				</div>
			</el-main>

		</el-container>
	</div>



</template>

<script>
	import { mapState, mapMutations } from 'vuex';
	import { getMyInfo,getBalance } from '@/config/api';
	export default {
		name: 'Login',
		components: {

		},
		// 定义属性
		data() {
			return {
				'phone': '',
				'password': '',
				cardstyle: {
					'border-radius': '100px',
				},
				yszc: false,
				yhtk: false
			}
		},
		methods: {
			...mapMutations(['setUserInfo']),
			login() {
			    if (this.phone == '' || this.password == '') {
			        this.$message.error('用户名或密码不能为空')
			        return
			    }
			    var httpData = {
			        phone: this.phone,        // 参数 firstName
			        password: this.password    // 参数 lastName
			    }
				this.$http.post("/api/user/login",httpData).then(res => {
					// 储存登录信息
					this.setUserInfo(res.userinfo)
					getMyInfo()
					getBalance()
					this.$message({
						 message: '登录成功',
						 type: 'success'
					});
					setTimeout(()=>{
						this.$router.push('/user/index')
					},500)
				})
			}
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {

		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {

		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>

<style scoped>
	.h1 {
		font-weight: 800;
		line-height: 1.25;
		letter-spacing: -.02em;
		font-size: 2.625rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.bg {
		height: 100%;
		width: 100%;
		/* position: fixed; */
		/* top: 0;
    bottom: 0;
    left: 0;
    right: 0; */
		/* display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; */
		/* background-color: rgb(52, 52, 52) */
		/* background: url("../assets/login.jpeg"); */
		/* background-size: 100% 100%; */
	}

	.dlym_bg {
		/* position: absolute; */
		/* min-height: 501px; */
		/* min-width: 384px; */
		width: 100%;
		max-width: 384px;
		background-color: #ffffff;
		border-radius: 30px;
		box-shadow: 0 0 20px 5px #efefef;

	}

	.el-input__inner {
		height: 300px;
	}
</style>